// Design Tokens - Colors
// Use these tokens for all color values in prototypes

export const colors = {
  // Brand colors (Figma design - blue primary, no purple)
  brand: {
    primary: {
      base: '#1e6ef6', // Blue from Figma
      light: '#60A5FA', // Lighter blue
      dark: '#1449e8', // Darker blue
    },
    purple: {
      // Legacy - map to blue for compatibility
      base: '#1e6ef6',
      light: '#60A5FA',
      dark: '#1449e8',
    },
    blue: {
      base: '#1e6ef6', // Primary blue from Figma
      light: '#60A5FA',
      dark: '#1449e8',
    },
    cyan: {
      base: '#06B6D4',
      light: '#22D3EE',
      dark: '#0891B2',
    },
    red: {
      base: '#f61e1e',
      light: '#f5841f',
      dark: '#cc6228',
    },
    yellow: {
      base: '#f0b90b',
      light: '#dfab06',
      dark: '#f1b90c',
    },
    orange: {
      base: '#e27525',
      light: '#ff9500',
      dark: '#e17726',
    },
  },

  // Text colors (Light theme)
  text: {
    primary: {
      default: '#000000', // Black for light theme
    },
    secondary: {
      default: '#4B5563', // Dark gray for light theme
    },
    muted: {
      default: '#9CA3AF', // Medium gray
    },
    disabled: {
      default: '#D1D5DB', // Light gray for disabled
    },
  },

  // Neutral colors (Standard gray scale for light theme)
  neutral: {
    white: '#ffffff',
    black: '#000000',
    gray: {
      50: '#F9FAFB',   // Lightest - page backgrounds
      100: '#F3F4F6',  // Very light - hover states
      200: '#E5E7EB',  // Light - borders, dividers
      300: '#D1D5DB',  // Medium light - disabled text
      400: '#9CA3AF',  // Medium - muted text
      500: '#6B7280',  // Medium dark - secondary text
      600: '#4B5563',  // Dark - labels
      700: '#374151',  // Darker - headings
      800: '#1F2937',  // Very dark - emphasis
      900: '#111827',  // Darkest - high contrast
    },
  },

  // Background colors (Light theme)
  background: {
    primary: {
      default: '#ffffff', // White - main backgrounds
    },
    secondary: {
      default: '#F9FAFB', // Very light gray - sections
    },
    tertiary: {
      default: '#F3F4F6', // Light gray - nested sections
    },
    pageBackground: {
      primary: '#ffffff', // White - page background
    },
    card: {
      default: '#ffffff', // White cards
      elevated: '#10131b', // Dark card for accent (like calculator results)
    },
  },

  // Border colors (Light theme)
  border: {
    default: {
      default: '#E5E7EB', // Light gray borders
    },
    subtle: {
      default: '#F3F4F6', // Very subtle borders
    },
    emphasis: {
      default: '#1e6ef6', // Blue for emphasized borders
    },
  },

  // Semantic colors
  semantic: {
    success: '#10B981',
    warning: '#f0b90b',
    error: '#f61e1e',
    info: '#1e6ef6',
  },

  // Status colors
  status: {
    success: {
      base: '#10B981',
      default: '#10B981',
      light: '#34D399',
      dark: '#059669',
    },
    warning: {
      base: '#f0b90b',
      default: '#f0b90b',
      light: '#dfab06',
      dark: '#f1b90c',
    },
    error: {
      base: '#f61e1e',
      default: '#f61e1e',
      light: '#f5841f',
      dark: '#cc6228',
    },
    info: {
      base: '#1e6ef6',
      default: '#1e6ef6',
      light: '#353fff',
      dark: '#1449e8',
    },
  },
} as const;
